<main class="weather-page">
  <header class="weather-header">
    <div class="title-row">
      <a
        class="back-icon"
        routerLink="/dashboard"
        aria-label="Back to state dashboard"
        >‹</a
      >
      <div>
        <span class="page-eyebrow">Weather intelligence</span>
        <h1>{{ station().name }} Weather Dashboard</h1>
        <nav>
          <a routerLink="/dashboard">Home</a><span>›</span
          ><span>Weather Dashboard</span><span>›</span
          ><strong>{{ station().name }}</strong>
        </nav>
      </div>
    </div>
    <a class="outline-button" routerLink="/dashboard"
      >← Back to State Dashboard</a
    >
  </header>

  <section
    class="station-overview"
    [attr.data-alert]="station().alert.toLowerCase()"
  >
    <div class="current-weather">
      <span class="hero-kicker"><i></i> Live conditions</span>
      <h2>{{ station().district }} Pooling Sub Station (PSS)</h2>
      <div class="current-weather-value">
        <span class="hero-weather-icon">{{ station().icon }}</span>
        <div>
          <b>{{ station().condition }}</b
          ><strong>{{ station().temperature }}°</strong
          ><small>Feels like {{ station().temperature + 1 }}°C</small>
        </div>
      </div>
    </div>
    <div class="overview-facts">
      <div class="overview-fact">
        <i class="fact-icon update">↻</i><span>Last Updated</span
        ><strong>{{ currentDateTimeLabel }}</strong>
      </div>
      <div class="overview-fact">
        <i class="fact-icon healthy">✓</i><span>Communication</span
        ><strong><em>Healthy</em><small>All sensors online</small></strong>
      </div>
      <div class="overview-fact">
        <i class="fact-icon confidence">✦</i><span>Forecast Confidence</span
        ><strong
          ><em>{{ station().confidence }}%</em
          ><small>High confidence</small></strong
        >
      </div>
      <div class="overview-fact">
        <i
          class="fact-icon alert-state"
          [class.warning]="station().alert === 'Medium'"
          [class.danger]="
            station().alert === 'High' || station().alert === 'Critical'
          "
          >!</i
        ><span>Weather Alert</span
        ><strong
          ><em>{{ station().alert }}</em
          ><small>Operational impact</small></strong
        >
      </div>
    </div>
  </section>

  <section class="metrics-grid" aria-label="Current weather metrics">
    @for (metric of metrics(); track metric.label) {
      <article
        class="metric-card"
        [class.wide]="metric.wide"
        [class]="metric.tone"
      >
        <i class="metric-icon" aria-hidden="true">{{
          metric.icon === "thermometer" ? "♨" : metric.icon
        }}</i>
        <div>
          <span class ="metric-label">{{ metric.label }}</span
          ><strong>{{ metric.value }}</strong
          ><small>{{ metric.note || "Current reading" }}</small>
        </div>
      </article>
    }
  </section>

  <section class="forecast-insights" aria-label="Seven day forecast highlights">
    <div class="insights-heading">
      <span>7-day outlook</span
      ><strong>Weather signals that may affect generation</strong>
    </div>
    @for (insight of forecastInsights(); track insight.label) {
      <article [class]="insight.tone">
        <i>{{ insight.icon }}</i>
        <div>
          <span>{{ insight.label }}</span
          ><strong>{{ insight.value }}</strong
          ><small>{{ insight.note }}</small>
        </div>
      </article>
    }
  </section>

  <section class="forecast-card">
    <div class="card-heading">
      <div>
        <span class="section-kicker">Forecast timeline</span>
        <h2>Next 7 Days Forecast</h2>
      </div>
      <a
        [routerLink]="[
          '/weather-dashboard',
          stationId,
          'hourly',
          forecast[0].key,
        ]"
        >View Hourly Guide <b>→</b></a
      >
    </div>
    <div class="forecast-table-wrap">
      <table>
        <thead>
          <tr>
            <th>Day</th>
            <th>Weather</th>
            <th>Min / Max Temp (°C)</th>
            <th>POA Irradiance (kWh/m²)</th>
            <th>Wind (m/s)</th>
            <th>Rain (mm)</th>
            <th>Humidity (%)</th>
            <th>Cloud Cover (%)</th>
            <th>AQI</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (day of forecast; track day.key) {
            <tr>
              <td>
                <strong>{{ day.short }}</strong>
              </td>
              <td>
                <span class="condition"
                  ><i>{{ day.icon }}</i
                  >{{ day.weather }}</span
                >
              </td>
              <td>{{ day.min }} / {{ day.max }}</td>
              <td>{{ day.irradiance }}</td>
              <td>{{ day.wind }}</td>
              <td>{{ day.rain }}</td>
              <td>{{ day.humidity }}</td>
              <td>{{ day.cloud }}</td>
              <td>
                <span class="aqi" [class]="day.tone">{{ day.aqi }}</span>
              </td>
              <td>
                <a
                  class="row-action"
                  [routerLink]="[
                    '/weather-dashboard',
                    stationId,
                    'hourly',
                    day.key,
                  ]"
                  >View Hourly Forecast</a
                >
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
</main>
